import { $window, $body, Breakpoints } from '../../../Constants';
import HtmlElement from '../../../Elements/HtmlElement';

/**
 * Timetable
 */
const Timetable = (() => {
  // Constants
  const DATA_KEY = 'ig.timetable';
  const EVENT_KEY = `.${DATA_KEY}`;

  /**
   * Selector
   *
   * @var { Object }
   */
  const Selector = {
    TIMETABLE: '.tx-timetable-pi1',
    DAY: '.day',
    COURSES: '.courses',
    COURSE: '.tt_course',
    AFTERNOON: '.tt_afternoon'
  };

  /**
   * ClassName
   *
   * @var { Object }
   */
  const ClassName = {
    AFTERNOON: 'tt_afternoon',
    AFTERNOON_FIRST: 'tt_afternoon_first'
  };

  /**
   * Event
   */
  const Event = {
    RESIZE: `resize${EVENT_KEY}`,
    COURSE_CLICK: `click.course${EVENT_KEY}`
  };

  /**
   * Timetable
   *
   * @class
   * @augments HtmlElement
   */
  class Timetable extends HtmlElement {
    /**
     * @constructor
     */
    constructor($element) {
      super($element);

      this._separatedDays = false;
      this._isCollapsed = false;
    }

    // Public

    /**
     * Handles ready event
     *
     * @return void
     */
    onReady() {
      this._$courses = this.$element.find(Selector.COURSES);

      if($body.find(Selector.TIMETABLE).length === 2) {
        this._separatedDays = true;
        this._$afternoonTimetable = this._getAfternoonTimetable();
      }

      this._bindHandlers();
      this._checkCollapse();
    }

    // Private

    /**
     * Binds the event handlers to the elements
     *
     * @return void
     */
    _bindHandlers() {
      $window.on(Event.RESIZE, () => {
        this._checkCollapse();
      });
    }

    /**
     * Checks if the courses should be collapsed
     *
     * @return void
     */
    _checkCollapse() {
      if(this._isCollapsed) {
        if($window.width() >= Breakpoints.LARGE) {
          this._uncollapse();
        }
      } else {
        if($window.width() < Breakpoints.LARGE) {
          this._collapse();
        }
      }
    }

    /**
     * Collapses the courses
     *
     * @return void
     */
    _collapse() {
      if(this._separatedDays) {
        this._addAfternoonCourses();
      }

      this.$element.find(Selector.DAY).on(Event.COURSE_CLICK, (e) => {
        this._$courses.slideUp(300);
        $(e.target).next(Selector.COURSES).stop(true, false).slideToggle(300);
      });

      this._$courses.css('display', 'none');
      this._isCollapsed = true;
    }

    /**
     * Uncollapses the courses
     *
     * @return void
     */
    _uncollapse() {
      if(this._separatedDays) {
        this._removeAfternoonCourses();
      }

      this.$element.find(Selector.DAY).off('click');
      this._$courses.css({
        'display': 'block',
        'height': ''
      });

      this._isCollapsed = false;
    }

    /**
     * Returns the afternoon timetable
     *
     * @return { $body }
     */
    _getAfternoonTimetable() {
      return $body.find(Selector.TIMETABLE).eq(1);
    }

    /**
     * Adds the afternoon courses
     *
     * @return void
     */
    _addAfternoonCourses() {
      this.$element.find('.row > .column').each((i, timetableColumn) => {
        let $afternoonCourses = this._$afternoonTimetable.find('.row > .column').eq(i).find(Selector.COURSE);

        if($afternoonCourses.length > 0) {
          $afternoonCourses.addClass(ClassName.AFTERNOON);
          $afternoonCourses.first().addClass(ClassName.AFTERNOON_FIRST);
          $(timetableColumn).find(Selector.COURSES).append($afternoonCourses);
        }
      });
    }

    /**
     * Removes the afternoon courses
     *
     * @return void
     */
    _removeAfternoonCourses() {
      this.$element.find('.row > .column').each((i, timetableColumn) => {
        let $afternoonCourses = $(timetableColumn).find(Selector.AFTERNOON);

        if($afternoonCourses.length > 0) {
          $afternoonCourses.removeClass(`${ClassName.AFTERNOON} ${ClassName.AFTERNOON_FIRST}`);
          this._$afternoonTimetable.find('.row > .column').eq(i).find(Selector.COURSES).append($afternoonCourses);
        }
      });
    }
  }

  return Timetable._getElements($body.find(Selector.TIMETABLE), Timetable);
})();

export default Timetable;
